<section class="row container w-100 text-center mt-1 p-1">
  <section class="col-12 d-flex justify-content-center align-items-center mb-1">
    <button (click)="before()" [disabled]="actualPage == 1" class="btn btn-light d-flex align-items-center mr-1"><mat-icon>navigate_before</mat-icon></button>
    <input type="text" size="4" [value]="actualPage" class="text-center" id="search">
    <button (click)="next()" [disabled]="actualPage == totalPages" class="btn btn-light d-flex align-items-center ml-1"><mat-icon>navigate_next</mat-icon></button>
  </section>
  <section class="col-12 justify-content-center">
    Número de páginas: {{ totalPages }}
  </section>
  <section class="col-12 justify-content-center">
    Resultados: {{ totalElements }}
  </section>
</section>
